import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import logo from "../LOGO.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`fixed top-0 w-full py-1 lg:py-2 z-50 transition-all duration-300 ease-in-out ${
        isScrolled ? "bg-cyan-900 shadow-md text-white" : "bg-transparent"
      }`}
    >
      <nav className="max-w-5xl mx-auto px-5 py-2.5 lg:py-4">
        <div className="flex items-center justify-between relative">
          <Link to="/">
            <img
              src={logo}
              alt="DOMP"
              className="h-24 md:h-28 lg:h-32 w-auto absolute -top-4 md:-top-6"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden lg:flex space-x-10 text-base font-bold transition-colors duration-300">
            <Link to="/" className={`hover:underline hover:underline-offset-4 transition-all duration-100 ease-linear text-cyan-900 ${isScrolled ? "text-white" : "text-cyan-900"}`} >Home</Link>
            <Link to="/services" className={`hover:underline hover:underline-offset-4 transition-all duration-100 ease-linear text-cyan-900 ${isScrolled ? "text-white" : "text-cyan-900"}`} >Service</Link>
            <Link to="/vulnerablepeople" className={`hover:underline hover:underline-offset-4 transition-all duration-100 ease-linear text-cyan-900 ${isScrolled ? "text-white" : "text-cyan-900"}`} >Vulnerable People</Link>
            <Link to="/contactus" className={`hover:underline hover:underline-offset-4 transition-all duration-100 ease-linear text-cyan-900 ${isScrolled ? "text-white" : "text-cyan-900"}`} >Contact</Link>
          </div>

          {/* Mobile Menu Toggle */}
          <button
            className="block lg:hidden"
            onClick={() => setIsMenuOpen((prev) => !prev)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`h-8 w-8 ${isScrolled ? "text-white" : "text-cyan-900"}`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth={2}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        <div
          ref={menuRef}
          className={`lg:hidden absolute left-0 right-0 bg-cyan-900 text-white shadow-md p-5 mt-2 transition-all duration-300 ease-in-out ${isMenuOpen ? "block" : "hidden"}`}
        >
          <ul className="flex flex-col space-y-4 text-center">
            <li><Link to="/" onClick={() => setIsMenuOpen(false)} className="hover:underline">Home</Link></li>
            <li><Link to="/services" onClick={() => setIsMenuOpen(false)} className="hover:underline">Service</Link></li>
            <li><Link to="/vulnerablepeople" onClick={() => setIsMenuOpen(false)} className="hover:underline">Vulnerable People</Link></li>
            <li><Link to="/contactus" onClick={() => setIsMenuOpen(false)} className="hover:underline">Contact</Link></li>
          </ul>
        </div>
      </nav>
    </div>
  );
};

export default Header;
